"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepsBannerPropType = exports.StepPropType = exports.StepIconLabelPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StepPropType = exports.StepPropType = _propTypes.default.shape({
  label: _propTypes.default.string,
  isActive: _propTypes.default.bool
});
const StepsBannerPropType = exports.StepsBannerPropType = {
  steps: _propTypes.default.arrayOf(StepPropType),
  bannerStyle: _propTypes.default.oneOf(['arrows', 'bullets', 'tabs']),
  arrowStyle: _propTypes.default.oneOf(['default', 'compact']),
  customCssClass: _propTypes.default.string,
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: _propTypes.default.any,
  customTrackingEvents: _propTypes.default.arrayOf(_propTypes.default.string),
  onCompletedStepClick: _propTypes.default.func
};
const StepIconLabelPropType = exports.StepIconLabelPropType = {
  isActive: _propTypes.default.bool,
  isCompleted: _propTypes.default.bool,
  stepIndex: _propTypes.default.number,
  label: _propTypes.default.string
};